import React from 'react';
import { FiInstagram, FiMail, FiPhone } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import logoWhite from '../images/The lashroom logo/whitelogo.svg';
import { useLanguage } from '../i18n/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-brand-dark text-brand-cream py-16 pb-24 md:pb-16 relative">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-12 border-b border-white/10 pb-12">
        
        {/* Brand */}
        <div>
          <img src={logoWhite} alt="The Lash Room" className="h-10 w-auto mb-4" />
          <p className="text-white/60 font-light text-sm max-w-xs mb-6">
            {t('footer.blurb')}
          </p>
          <div className="flex gap-4">
            <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-brand-taupe transition-colors">
              <SafeIcon icon={FiInstagram} className="w-5 h-5" />
            </a>
            <a href="mailto:hello@thelashroom.ca" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-brand-taupe transition-colors">
              <SafeIcon icon={FiMail} className="w-5 h-5" />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="font-medium mb-6 uppercase tracking-widest text-sm text-white/80">{t('footer.quickLinks')}</h4>
          <ul className="space-y-3 text-white/60 font-light text-sm">
            <li><a href="#services" className="hover:text-brand-taupe transition-colors">{t('footer.servicesPricing')}</a></li>
            <li><a href="#about" className="hover:text-brand-taupe transition-colors">{t('footer.aboutStudio')}</a></li>
            <li><a href="#location" className="hover:text-brand-taupe transition-colors">{t('footer.locationHours')}</a></li>
            <li><a href="#faq" className="hover:text-brand-taupe transition-colors">{t('footer.faqPrep')}</a></li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="font-medium mb-6 uppercase tracking-widest text-sm text-white/80">{t('footer.contact')}</h4>
          <ul className="space-y-3 text-white/60 font-light text-sm">
            <li className="flex items-center gap-2">
              <SafeIcon icon={FiPhone} className="w-4 h-4 text-brand-taupe" />
              <a href="tel:5142954267" className="hover:text-brand-taupe transition-colors">(514) 295-4267</a>
            </li>
            <li>79 Rue Saint-Antoine</li>
            <li>Sainte-Geneviève, QC H9H 2P6</li>
          </ul>
        </div>

      </div>
      
      <div className="max-w-7xl mx-auto px-6 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-white/40 font-light">
        <p>&copy; {new Date().getFullYear()} The Lash Room. {t('footer.rights')}</p>
        <p className="mt-2 md:mt-0">{t('footer.designed')}</p>
      </div>
    </footer>
  );
};

export default Footer;
